import { TestActionTypes } from "../constants/TestActionTypes";

const addTestDetails = (testData) => {
    return (dispatch) => {
        dispatch({ type: TestActionTypes.ADD_TEST_DETAILS, payload: testData });
    }

}

const updateTestDetails = (testData) => {
    return (dispatch) => {
        dispatch({ type: TestActionTypes.UPDATE_TEST_DETAILS, payload: testData });
    }

}

const incScreenLeftCount = () => {
    return (dispatch) => {
        dispatch({ type: TestActionTypes.INC_SCREEN_COUNT, payload: {} });
    }

}

export {
    addTestDetails,
    updateTestDetails,
    incScreenLeftCount
}